<template>
  <div class="machine-hire height-100">

    <!-- CUSTOMER MODAL -->
    <b-modal :active.sync="showCustomerForm">
      <div class="box flex-col" style="max-width: 400px; margin: 0 auto;">
        <div class="font-size-120 bold margin-bottom-5">
          {{ editCustomer ? 'Edit' : 'Add' }} Customer
        </div>
        <div class="flex-1">
          <sdf-form :fields="customerFields" :data="editCustomer" ref="customerForm" />
        </div>
        <div class="buttons margin-top flex">
          <div class="flex-1">
            <button class="button is-small" @click="showCustomerForm = false; showMachineBookingModal = true">Close</button>
          </div>
          <div>
            <button class="button is-small is-info" :class="{'is-loading': submittingCustomer}" @click="onSubmitCustomer()">{{  editCustomer ? 'Update' : 'Add'}}</button>
          </div>
        </div>

      </div>
    </b-modal>

    <b-modal :active.sync="showMachineBookingModal">
      <div class="box" style="max-width: 400px; margin: 0 auto;" v-if="selected">

        <div class="bold font-size-150">{{ selected.fromTimestamp | unixToDateString }} to {{ selected.toTimestamp | unixToDateString }}</div>

        <div class="bold font-size-130">{{ selected.machine.name }}</div>

        <div v-if="selectedBookingCustomer === null" class="pad-20 font-size-200 has-text-grey-light">
          <fa icon="spinner" pulse />
        </div>
        <div v-else-if="selectedBookingCustomer" class="pad has-text-grey bg-eee margin-top" style="border-radius: 7px;">
          <div class="font-size-80 bold flex">
            <div>BOOKED BY</div><div class="flex-1 right">{{ selected.bookingTimestamp | unixToDateString }}</div>
          </div>
          <div class="font-size-130 bold cursor-pointer" @click="onEditCustomer(selectedBookingCustomer)">
            {{ selectedBookingCustomer | name }}
            <fa icon="edit" class="margin-left-20" />
          </div>
          <div v-if="selectedBookingCustomer.phone" class="font-size-80">PH: {{ selectedBookingCustomer.phone || '-' }}</div>
          <div v-if="selectedBookingCustomer.email" class="font-size-80">EMAIL: {{ selectedBookingCustomer.email || '-' }}</div>
          <div v-if="selectedBookingCustomer.comments" class="comments margin-top-5 pad-top-5 font-size-80" style="border-top: solid 1px #ccc">
            {{ selectedBookingCustomer.comments }}
          </div>
        </div>

        <div class="margin-top-5">
          <div class="bold poiner" @click="onEditBookingComments(selected)">
            {{ showEditComments ? 'EDIT ' : '' }}COMMENTS <fa v-if="!showEditComments" icon="edit" class="margin-left-20" />
          </div>
          <template v-if="showEditComments">
            <b-input type="textarea" v-model="commentsStr" />
            <div class="buttons margin-top flex">
              <div class="flex-1">
                <button class="button is-small" :disabled="submittingComments" @click="showEditComments = false">Cancel</button>
              </div>
              <div>
                <button class="button is-small is-success" :class="{'is-loading': submittingComments}" @click="submitComment()">Update</button>
              </div>
            </div>
          </template>
          <template v-else>
            {{ this.selected.comments || '-' }}
          </template>
        </div>

        <div class="buttons pad-top" v-if="!showEditComments">
          <div class="flex-1">
            <button class="button is-danger" :class="{'is-loading': submitting === 'cancel'}" @click="onCancel(selected)">Cancel Booking</button>
          </div>
          <div>
            <button class="button" @click="showMachineBookingModal = false">Close</button>
          </div>
        </div>

      </div>
    </b-modal>

    <add-machine-booking v-if="showAddMachineHire" @close="showAddMachineHire = false" />

    <div class="pad" v-if="!showAddMachineHire">
      <div class="center pad-bottom-10">
        <button class="button is-info" @click="showAddMachineHire = true">Book Machine</button>
      </div>
      <div class="month">
        <div class="month-heading flex">
          <div class="pointer pad-right" @click="move(-1)"><fa icon="angle-left" /></div>
          <div class="flex-1">{{ monthStr }}</div>
          <div class="pointer pad-left" @click="move(1)"><fa icon="angle-right" /></div>
        </div>
        <div class="weeks-headings">
          <div class="weeks-heading flex-1" v-for="w in weekHeadings" :key="w">{{ w }}</div>
        </div>
        <div class="weeks">
          <div class="week" v-for="(week, weekIndex) in weeks" :key="weekIndex">
            <div class="day flex-1"
              :class="{ 'not-this-month': day.month !== month }" v-for="day in week" :key="day.timestamp"
              :style="{'min-height': cellHeight}"
            >
              <div class="day-title">
                <span class="pad-right-5 day-name">{{ day.dayName }}</span>
                <span class="date">{{ day.date }}</span>
              </div>
              <div class="day-content">
                <template  v-for="(booking, bookingIndex) in day.bookings">
                  <div v-if="booking"
                    :key="bookingIndex"
                    class="day-booking pointer"
                    :class="getBookingClass(day, booking, bookingIndex)"
                    @click="onClickBooking(booking)"
                  >
                    {{ booking.machine.name }}
                  </div>
                  <div v-else class="day-booking empty" :key="bookingIndex">&nbsp;</div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
    <br />

  </div>
</template>

<script>
import AddMachineBooking from '@/components/AddMachineBooking'
import SdfForm from '@/components/SdfForm'

export default {
  components: { AddMachineBooking, SdfForm },
  data () {
    return {
      showAddMachineHire: false,
      timestamp: 0,
      fromTimestamp: 0,
      toTimestamp: 0,
      month: null,
      monthStr: null,
      weekHeadings: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
      weeks: null,
      days: {},
      bookingCount: 0,
      showMachineBookingModal: false,
      selected: null,
      submitting: null,
      selectedBookingCustomer: null,
      machineMap: {},
      showCustomerForm: false,
      editCustomer: null,
      submittingCustomer: false,
      customerFields: [
        { key: 'firstName', required: true },
        { key: 'lastName' },
        { key: 'phone' },
        { key: 'email', input: 'email' },
        { key: 'comments', input: 'textarea' }
      ],
      commentsStr: null,
      showEditComments: false,
      submittingComments: false
    }
  },
  computed: {
    user () { return this.$store.getters.user },
    canHireMachines () { return this.user && this.user.privileges.includes('machine hire') },
    cellHeight () { return `${Math.max(100, 10 + (this.bookingCount + 1) * 22)}px` }
  },
  created () {
    this.timestamp = this.$moment().startOf('month').unix()
    this.initWeeks()
  },
  methods: {
    onCancel (booking) {
      this.submitting = 'cancel'
      this.deleteBooking(booking)
    },
    async deleteBooking (booking) {
      let showingModal = this.showMachineBookingModal
      this.showMachineBookingModal = false
      let comfirmed = await this.$confirm({
        type: 'is-danger',
        title: `${this.submitting.toUpperCase()} BOOKING`,
        message: `Are you sure you want to ${this.submitting} this booking?`
      })
      this.showMachineBookingModal = showingModal
      if (comfirmed) {
        await this.$fs.collection('machineBookings').doc(booking._id).delete()
        this.showMachineBookingModal = false
      }
      this.submitting = null
    },
    getBookingClass (day, booking, index) {
      const machineIdex = this.machineMap[booking.machine._id] || 0
      let classes = [`color-${machineIdex}`, 'approved']
      if (booking.fromTimestamp === day.timestamp) classes.push('start')
      if (booking.toTimestamp === day.timestamp) classes.push('end')
      return classes
    },
    async onClickBooking (booking) {
      this.selected = booking
      this.selectedBookingCustomer = null
      this.showMachineBookingModal = true

      try {
        let ss = await this.$fs.doc(`/machineBookingCustomers/${booking.customerId}`).get()
        this.selectedBookingCustomer = this.$ssToObj(ss)
      } catch (error) {
        console.error(error)
      }

      if (!this.selectedBookingCustomer && booking.customer) {
        this.selectedBookingCustomer = booking.customer
      }
    },
    move (inc) {
      this.timestamp = this.$moment.unix(this.timestamp)
        .add(inc, 'months')
        .unix()
      this.initWeeks()
    },
    onMachineBookingsSnapshot (snapshot) {
      let data = this.$utils.snapshotToArr(snapshot)

      for (let timestamp in this.days) {
        this.days[timestamp].bookings = null
      }

      let bookingIndex = {}
      this.bookingCount = 0

      let machineMap = {}
      let machineCount = 0
      for (let machineBooking of data) {
        let index = bookingIndex[machineBooking._id]
        if (index === undefined) {
          bookingIndex[machineBooking._id] = this.bookingCount++
        }
        index = machineMap[machineBooking.machine._id]
        if (index === undefined) {
          machineMap[machineBooking.machine._id] = machineCount++
        }
      }
      this.machineMap = machineMap
      // console.log('machineMap', machineMap)

      for (let machineBooking of data) {
        let fromTimestamp = Math.max(machineBooking.fromTimestamp, this.fromTimestamp)
        for (let timestamp = fromTimestamp; timestamp <= machineBooking.toTimestamp; timestamp += 60 * 60 * 24) {
          if (timestamp > this.toTimestamp) {
            break
          }
          let day = this.days[timestamp]
          if (!day) {
            // console.log('invalid day?', machineBooking)
            continue
          }
          if (!day.bookings) {
            day.bookings = []
            for (let i = 0; i < this.userCount; i++) day.bookings.push(null)
          }
          let i = bookingIndex[machineBooking._id]
          if (i === undefined) {
            // console.log('invalid booking index', bookingIndex)
          }
          day.bookings[i] = machineBooking
        }
      }
    },
    initWeeks () {
      let m = this.$moment.unix(this.timestamp)
      this.month = m.month()
      this.monthStr = m.format('MMMM YYYY')
      m = m.startOf('month').startOf('week').startOf('day')
      this.fromTimestamp = m.unix()
      this.toTimestamp = this.$moment.unix(this.timestamp).endOf('month').endOf('week').unix()
      let timestamp = this.fromTimestamp

      let weeks = []
      let week = null
      let days = {}

      let count = 0
      while (timestamp < this.toTimestamp && count < 100) {
        let day = {
          timestamp,
          year: m.year(),
          month: m.month(),
          date: m.date(),
          dayName: m.format('ddd'),
          bookings: []
        }
        let dow = m.day()
        days[timestamp] = day
        if (dow === 0) {
          week = []
          weeks.push(week)
        }
        week.push(day)
        m.add(1, 'day')
        timestamp = m.unix()
        count++
      }
      this.weeks = weeks
      this.days = days

      this.fetchMachineBookings()
    },
    fetchMachineBookings () {
      this.unsub('machineBookings')
      this.subs.machineBookings = this.$fs.collection('machineBookings')
        .where('months', 'array-contains', this.month)
        .orderBy('bookingTimestamp', 'asc')
        .onSnapshot(this.onMachineBookingsSnapshot)
    },
    onEditCustomer (customer) {
      console.log('onEditCustomer', customer)
      this.editCustomer = customer
      this.showMachineBookingModal = false
      this.showCustomerForm = true
    },
    async onSubmitCustomer () {
      let form = this.$refs.customerForm
      let data = form.submit()
      if (!data) return
      this.submittingCustomer = true
      try {
        console.log(data)
        await this.$fs.doc(`/machineBookingCustomers/${this.editCustomer._id}`)
          .update(data)
        this.selectedBookingCustomer = data
        this.editCustomer = null
        this.showCustomerForm = false
        this.showMachineBookingModal = true
      } catch (error) {
        this.$showError(error)
      }
      this.submittingCustomer = false
    },
    async onEditBookingComments (booking) {
      this.commentsStr = booking.comments
      this.showEditComments = true
    },
    async submitComment () {
      this.submittingComments = true
      try {
        await this.$fs.doc(`/machineBookings/${this.selected._id}`)
          .update({ comments: this.commentsStr.trim() })
        this.selected.comments = this.commentsStr.trim()
        this.showEditComments = false
      } catch (error) {
        this.$showError(error)
      }
      this.submittingComments = false
    }
  }
}
</script>

<style>
  .machine-hire .month {
    max-width: 1000px;
    margin: 0 auto;
    border: solid 2px #666;
  }

  .machine-hire .month-heading {
    padding: 10px;
    font-size: 1.1em;
  }

  .machine-hire .month-heading,
  .machine-hire .weeks-headings {
    text-align: center;
    color: #fff;
    background-color: #666;
    font-weight: bold;
  }

  .machine-hire .weeks-headings .weeks-heading {
    padding: 5px;
    font-size: 12px;
    /* border-right: solid 1px #ccc; */
    /* border-bottom: solid 2px #ccc; */
  }

  .machine-hire .weeks .week {
    display: flex;
  }

  .machine-hire .weeks .week .day {
    border-right: solid 2px #666;
    border-bottom: solid 2px #666;
    height: 100px;
    overflow: hidden;
  }

  .machine-hire .weeks .week .day .day-title {
    height: 20px;
    font-size: 11px;
    line-height: 20px;
    padding: 0 2px;
    font-weight: bold;
    color: #000;
    background-color: #dddd;
  }

  /* .machine-hire .weeks .week .day .day-content {
  } */

  .machine-hire .weeks .week .day.not-this-month {
    opacity: 0.5;
    background-color: #eee;
  }

  .machine-hire .weeks .week .day .day-content .day-booking {
    height: 18px;
    line-height: 15px;
    padding: 0 5px;
    margin: 2px 0;
    width: 100%;
    font-size: 12px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    border-top: solid 2px transparent;
    border-bottom: solid 2px transparent;
  }

  .machine-hire .weeks .week .day .day-content .day-booking.start {
    margin-left: 5%;
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
    border-left: solid 2px transparent;
  }

  .machine-hire .weeks .week .day .day-content .day-booking.end {
    width: 95%;
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
    border-right: solid 2px transparent;
  }

  .machine-hire .weeks .week .day .day-content .day-booking.start.end {
    width: 90%;
    margin-left: auto;
    margin-right: auto;
  }

  .machine-hire .weeks .week .day .day-content .day-booking.approved {
    font-weight: bold;
    /* color: #fff; */
    /* background-color: #167df0; */
  }

  .machine-hire .weeks .week .day .day-content .day-booking.approved.color-0 { background-color: mediumaquamarine; }
  .machine-hire .weeks .week .day .day-content .day-booking.approved.color-1 { background-color: navajowhite; }
  .machine-hire .weeks .week .day .day-content .day-booking.approved.color-2 { background-color: violet; }
  .machine-hire .weeks .week .day .day-content .day-booking.approved.color-3 { background-color: powderblue; }
  .machine-hire .weeks .week .day .day-content .day-booking.approved.color-4 { background-color: coral; }
  .machine-hire .weeks .week .day .day-content .day-booking.approved.color-5 { background-color: mediumturquoise; }
  .machine-hire .weeks .week .day .day-content .day-booking.approved.color-6 { background-color: lightpink; }
  .machine-hire .weeks .week .day .day-content .day-booking.approved.color-7 { background-color: yellowgreen; }

  .machine-hire .weeks .week .day .day-content .day-booking.pending.color-0 { border-color: mediumaquamarine; }
  .machine-hire .weeks .week .day .day-content .day-booking.pending.color-1 { border-color: navajowhite; }
  .machine-hire .weeks .week .day .day-content .day-booking.pending.color-2 { border-color: violet; }
  .machine-hire .weeks .week .day .day-content .day-booking.pending.color-3 { border-color: powderblue; }
  .machine-hire .weeks .week .day .day-content .day-booking.pending.color-4 { border-color: coral; }
  .machine-hire .weeks .week .day .day-content .day-booking.pending.color-5 { border-color: mediumturquoise; }
  .machine-hire .weeks .week .day .day-content .day-booking.pending.color-6 { border-color: lightpink; }
  .machine-hire .weeks .week .day .day-content .day-booking.pending.color-7 { border-color: yellowgreen; }

  @media screen and (min-width: 650px) {
    .machine-hire .weeks-headings { display: flex; }

    .machine-hire .weeks .week .day .day-title .day-name {
      display: none;
    }

    .machine-hire .weeks .week .day:last-child {
      border-right: none;
    }

    .machine-hire .weeks .week:last-child .day {
      border-bottom: none;
    }
  }

  @media screen and (max-width: 650px) {
    .machine-hire .weeks .week {
      display: block;
    }

    .machine-hire .weeks .week .day {
      border-right: none;
    }

    .machine-hire .weeks-headings,
    .machine-hire .weeks .week .day.not-this-month {
      display: none;
    }

    .machine-hire .month {
      border-bottom: none;
    }
  }
</style>
